import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

export const EstatusIcon = ({ld}) => {
  return (
    <div>
      {ld.ok ? (
        <CheckCircleOutlined style={{ fontSize: 15, color: "green" }} />
      ) : (
        <CloseCircleOutlined style={{ fontSize: 20, color: "red" }} />
      )}
    </div>
  );
};
